<template>
  <v-overlay v-model="$store.getters.GET_PAGE_LOADING"
             absolute opacity="1"
             color="primary"
             z-index="999">
    <v-row class="ma-0 pa-0 fill-height d-flex justify-center align-center">
      <v-col cols="5" class="d-flex justify-center">
        <v-progress-circular width="12" size="500" color="secondary" indeterminate>
          <v-img max-width="150"
                 src="@/assets/logo_circle.png"
                 alt="Sinculis Logo"></v-img>
        </v-progress-circular>
      </v-col>
    </v-row>
  </v-overlay>
</template>

<script>
export default {
  name: "LoadingPageComponent"
}
</script>

<style scoped>

</style>
